export const VERSION = '1.0.2';
export const GIT_SHA = 'f0e59ae8';
export const DIST = 'staging';
